import React, { useState } from 'react';
import { FaMapMarkerAlt, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {

  faPhone,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log('Subscribed with:', email);
    setEmail('');
    alert('Thank you for subscribing to our newsletter!');
  };

  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-container">
          {/* Organization Info */}
          <div className="footer-col">
            <h3 className="footer-title">ITY Tanzania</h3>
            <p className="footer-tagline">Itambue Thamani Yako</p>
            <p className="footer-description">
              Empowering Women, Girls and Children across Tanzania through education, 
              healthcare, and sustainable development programs.
            </p>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="#" className="social-link" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="#" className="social-link" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="#" className="social-link" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          {/* Contact Information */}
          <div className="footer-col">
            <h3 className="footer-title">Contact Us</h3>
            <p className="contact-item-footer">
              <FaMapMarkerAlt className="contact-icon" />
              Makulu, Dodoma, Tanzania
            </p>
            <p className="contact-item-footer">
              <FontAwesomeIcon icon={faPhone} className="contact-icon" />
              +255 689 729 148
            </p>
            <p className="contact-item-footer">
              <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
              itambuethamaniyakotz@gmail.com
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h3 className="footer-title">Quick Links</h3>
            <p><a href="#about" className="footer-link">About Us</a></p>
            <p><a href="#programs" className="footer-link">Our Programs</a></p>
            <p><a href="#gallery" className="footer-link">Gallery</a></p>
            <p><a href="#get-involved" className="footer-link">Get Involved</a></p>
          </div>

          {/* Newsletter */}
          <div className="footer-col">
            <h3 className="footer-title">Newsletter</h3>
            <p className="newsletter-description">
              Subscribe to our newsletter to receive updates about our work and how you can help.
            </p>
            <form onSubmit={handleSubmit} className="newsletter-form">
              <input 
                type="email" 
                placeholder="Your Email Address" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="newsletter-input"
              />
              <button type="submit" className="newsletter-btn">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Copyright */}
        <div className="copyright">
          <p>
            &copy; {new Date().getFullYear()} ITY Tanzania. All Rights Reserved. | 
            <span className="tagline"> Itambue Thamani Yako  </span>
            <a href="https://sj.co.tz" target="_blank" rel="noopener noreferrer" className="developer-credit">| Developed by sj.co.tz</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;